import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';
import { mq } from '@/theme/scalingTokens';

export const useSelectedSpacesAccordionStyles = makeStyles({
  accordion: {
    display: 'flex',
    flexDirection: 'column',
  },
  item: {
    ...shorthands.borderBottom('1px', 'solid', tokens.colorNeutralStroke2),
    ':last-child': {
      ...shorthands.borderBottom('0'),
    },
  },
  header: {
    // Fluent's AccordionHeader button owns padding; we tune the inner layout.
    '& button': {
      ...shorthands.padding(tokens.spacingVerticalM, '0'),
    },
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingHorizontalM),
    minWidth: 0,
    width: '100%',
  },
  indexBadge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '28px',
    height: '28px',
    flexShrink: 0,
    ...shorthands.borderRadius('50%'),
    ...shorthands.border('1px', 'solid', tokens.colorBrandStroke1),
    color: tokens.colorBrandForeground1,
    fontSize: fontScale.body,
    fontWeight: tokens.fontWeightSemibold,
  },
  headerText: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    ...shorthands.gap(tokens.spacingVerticalXXS),
  },
  headerTitle: {
    fontSize: fontScale.body,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase300,
    color: tokens.colorNeutralForeground1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  headerSummary: {
    fontSize: fontScale.caption,
    lineHeight: tokens.lineHeightBase200,
    color: tokens.colorNeutralForeground3,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  accordionPanel: {
    ...shorthands.margin('0'),
  },
  panel: {
    display: 'flex',
    ...shorthands.gap(tokens.spacingHorizontalXXL),
    ...shorthands.padding(tokens.spacingVerticalL, '0'),
    ...shorthands.borderTop('1px', 'solid', tokens.colorNeutralStroke2),
    [mq.tablet]: {
      flexDirection: 'column',
    },
  },
  image: {
    width: '160px',
    height: '135px',
    ...shorthands.borderRadius(tokens.borderRadiusXLarge),
    objectFit: 'cover',
    flexShrink: 0,
    [mq.tablet]: {
      width: '100%',
      height: '140px',
    },
  },
  detailGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: tokens.spacingHorizontalXXL,
    rowGap: tokens.spacingVerticalL,
    flexGrow: 1,
    minWidth: 0,
    [mq.mobile]: {
      gridTemplateColumns: '1fr',
    },
  },
  detailBlock: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    ...shorthands.gap(tokens.spacingVerticalXXS),
  },
  detailLabel: {
    fontSize: fontScale.body,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
  },
  detailValue: {
    fontSize: fontScale.body,
    lineHeight: tokens.lineHeightBase300,
    color: tokens.colorNeutralForeground1,
    overflowWrap: 'anywhere',
  },
});
